export const CONSTANTS: any = {
  filter: {
    success: 'Filtro aplicado com sucesso',
    empty: 'Não há registros'
  },
  components: {
    inspection: {
      index: 'Inspection',
      vehicle: 'InspectionVehicle',
      history: 'InspectionHistory',
      signature: 'InspectionSignature',
      photos: {
        vehicle: 'vehicle',
        breakdown: 'breakdown'
      },
      plateVerification: 'VehicleDataStep',
      report: 'InspectionReport'
    },
    refund: {
      index: 'Refund',
      new: 'NewRefund',
      edit: 'EditRefund'
    },
    precification: {
      index: 'Precification',
      batch: 'Batch Precification',
      new: 'Nova Precificação'
    },
    preparation: {
      index: 'Preparation',
      edit: 'EditPreparation',
      new: 'NewPreparation'
    }
  },
  pricedSurvey: {
    true: 'Sim',
    false: 'Não'
  },
  sla: {
    options: [
      { key: 'Dias', value: 1 },
      { key: 'Horas', value: 2 },
      { key: 'Minutos', value: 3 }
    ]
  },
  options: {
    vehicleStatus: [
      'Operacional A',
      'Operacional B',
      'Operacional C',
      'Operacional D',
      'Não operacional',
      'Avariado',
      'Sinistrado',
      'PT',
      'Não se Aplica'
    ],
    vehicleFinalizeStatus: [
      'Operacional A',
      'Operacional B',
      'Operacional C',
      'Operacional D',
      'Não Operacional',
      'Sinistrado',
      'PT',
      'Não se Aplica'
    ],
    vehicleType: ['Leve', 'Pesado']
  },
  allRegisters: 0,
  vehicle: {
    status: ['Leve', 'Pesado']
  }
}

export const SUCCESS_STATUS = [200, 201]

export const PHOTOS_PATHS = {
  CLIENT_SIGNATURE: 'vistoria/assinatura',
  INSPECTION_PHOTOS: 'veiculo/foto',
  INSPECTION_VIDEOS: 'veiculo/video'
}
